export type { MenuItem } from './charity-menu';
export { charityMenuItems } from './charity-menu';
export { adminMenuItems } from './admin-menu';
export { employerMenuItems } from './employer-menu';
export { userMenuItems } from './user-menu';

import type { MenuItem } from './charity-menu';
import { charityMenuItems } from './charity-menu';
import { adminMenuItems } from './admin-menu';
import { employerMenuItems } from './employer-menu';
import { userMenuItems } from './user-menu';

export function getMenuItemsByRole(role: string): MenuItem[] {
  switch (role) {
    case 'Charity':
      return charityMenuItems;
    case 'Admin':
      return adminMenuItems;
    case 'Employer':
      return employerMenuItems;
    case 'User':
    default:
      return userMenuItems;
  }
} 